export default "__VITE_ASSET__Pute4ymd__"